module.exports = __webpack_public_path__ + "static/media/tirumalabg.a552ccd7.jpg";